// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {

	if ( $('#cookiePolicy').length > 0 ) {
		var cookiePolicy = $('#cookiePolicy');
		cookiePolicy.hide();
		if(localStorage.getItem('cookieUse') === null) {

			// スクロール時の表示・非表示 // show/hide on scrolling
			$(window).on("scroll", dispAgree);

			// 同意ボタンクリック // click on the agree button
			$('#cookie_agree').on("click", function() {
				$(window).off("scroll", dispAgree);
				localStorage.setItem('cookieUse', 'agree');
				cookiePolicy.hide();
			})
		}

		//スクロールが100に達したらクッキー同意を表示 // Show cookie agreement when scroll reaches 100
		function dispAgree() {
			if ($(this).scrollTop() > 100) {
				cookiePolicy.fadeIn();
			} else {
				cookiePolicy.fadeOut();
			}
		}
	}


});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
jQuery(function($) {
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var headerHeight = $('.l-header').outerHeight() || 0;
            // l-sec の padding-top の半分だけ手前で止めて、ヘッダーとの余白を半分に
            var halfSecPadding = $(window).width() <= 768 ? 20 : 40;
            var position = target.offset().top - headerHeight + halfSecPadding;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function($) {
    if ( $('.obj_image').length > 0 ) {
        objectFitImages('.obj_image');
    }
});


// ページトップボタンの表示 // Display the page top button
/*
jQuery(function($) {

	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});
*/

// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// フロントFAQアコーディオンの起動
jQuery(function($) {
	if ( $('.js-faqAccordion .p-frontFaq__item').length === 0 ) {
		return;
	}

	var $items = $('.js-faqAccordion .p-frontFaq__item');

	function setPanelHeight($item, isOpen) {
		var $panel = $item.find('.p-frontFaq__panel').first();
		var $button = $item.find('.p-frontFaq__question').first();

		if (isOpen) {
			$item.addClass('is-open');
			$button.attr('aria-expanded', 'true');
			$panel.css('max-height', $panel.prop('scrollHeight') + 'px');
		} else {
			$item.removeClass('is-open');
			$button.attr('aria-expanded', 'false');
			$panel.css('max-height', '0px');
		}
	}

	$items.each(function() {
		var $item = $(this);
		setPanelHeight($item, $item.hasClass('is-open'));
	});

	$('.js-faqAccordion .p-frontFaq__question').on('click', function() {
		var $item = $(this).closest('.p-frontFaq__item');
		var isOpen = $item.hasClass('is-open');
		setPanelHeight($item, !isOpen);
	});

	$(window).on('resize', function() {
		$items.each(function() {
			var $item = $(this);
			if ($item.hasClass('is-open')) {
				var $panel = $item.find('.p-frontFaq__panel').first();
				$panel.css('max-height', $panel.prop('scrollHeight') + 'px');
			}
		});
	});
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$(this).attr({
					'aria-expanded': 'true',
					'aria-label': 'メニューを閉じる'
				});
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$(this).attr({
					'aria-expanded': 'false',
					'aria-label': 'メニューを開く'
				});
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active').attr({
				'aria-expanded': 'false',
				'aria-label': 'メニューを開く'
			});
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		// ヘッダーナビ内のリンクのみを対象にする（フッターナビでドロワーが開かないように）
		$('#global-nav a').on('click', function(){
			if ($('#toggle').hasClass('toggle_active')) {
				$('#toggle').click();
			}
		});
	}

});


// 画面下部固定 CTA の表示制御（先頭は非表示／スクロールで表示／フッターで非表示）
(function() {
    var floatingCta = document.querySelector('.c-floatingCta');
    if (!floatingCta) return;

    var SCROLL_THRESHOLD = 100;
    var isInFooter = false;

    function updateVisibility() {
        var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > SCROLL_THRESHOLD;
        if (scrolled && !isInFooter) {
            floatingCta.classList.add('is-show');
        } else {
            floatingCta.classList.remove('is-show');
        }
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    var footer = document.querySelector('.l-footer');
    if (footer && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
            for (var i = 0; i < entries.length; i++) {
                isInFooter = entries[i].isIntersecting;
            }
            updateVisibility();
        }, {
            rootMargin: '0px',
            threshold: 0
        });
        observer.observe(footer);
    }

    updateVisibility();
})();


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});
